/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { ISchemaIconNameModel, isSchemaIconNameModel } from "@adapptio/lib-blueprint";
import { INSPECTOR_NODE_TYPE, isInspectorNodeDefault, TInspectorNode } from "../InspectorNodeTypes";
import { mapModelToNodes } from "../index";
import { mapperDescriptor } from "../../modules/Core/ReferenceGuide/mappers/mapperDescriptor";
import { mapperExamples } from "../../modules/Core/ReferenceGuide/mappers/mapperExamples";
import { getParentComponentName } from "../utils";

export function iconNameMapper(model: ISchemaIconNameModel): TInspectorNode {
	if (!isSchemaIconNameModel(model)) {
		return;
	}

	const nameNode = mapModelToNodes(model.name);

	const controls = isInspectorNodeDefault(nameNode) ? nameNode.controls : [];

	return {
		type: INSPECTOR_NODE_TYPE.DEFAULT,
		key: `${model.nodeId}`,
		label: model.schema.opts.label,
		tooltip: model.schema.opts.description,
		options: model.schema.opts["options"],
		required: model.schema.opts.constraints?.required || false,
		default: model.schema.opts.default || null,
		referenceData: getParentComponentName(model),
		descriptor: mapperDescriptor(model.schema),
		examples: mapperExamples(model.schema),
		deps: [ model.name, ...nameNode.deps ],
		controls: [ ...controls ],
		children: []
	};
}
